const initState = {
  classes: [
    {
      id: "1",
      name: "Math course",
      description: "Learn math",
      teacherFirstName: "Grace",
      teacherLastName: "Yan",
    },
    {
      id: "2",
      name: "Math course",
      description: "Learn math",
      teacherFirstName: "Grace",
      teacherLastName: "Yan",
    },
    {
      id: "3",
      name: "Math course",
      description: "Learn math",
      teacherFirstName: "Grace",
      teacherLastName: "Yan",
    },
  ],
};

const classReducer = (state = initState, action) => {
  return state;
};

export default classReducer;
